import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./style.scss";

const RadioButtonGroup = ({ selectedOption, options, onChange, isDisabled, html, alignment, horizontal }) => {
  const [checked, setChecked] = useState(selectedOption);
  useEffect(() => {
    setChecked(selectedOption);
  }, [selectedOption]);
  const handleSelect = option => {
    setChecked(option);
    onChange(option);
  };

  const selectWithKeyboardKeys = (event, option) => {
    const SPACE = 32;
    const ENTER = 13;
    if (event.target.tagName === "DIV" && (event.keyCode === SPACE || event.keyCode === ENTER)) {
      event.preventDefault();
      handleSelect(option);
    }
  };
  const radioGroupClassList = classNames("radio-group", {
    horizontal: horizontal
  });
  return (
    <div className={radioGroupClassList}>
      {options.map((option, index) => {
        const { label, value } = option;
        const radioButtonClassList = classNames({
          checked: checked?.value === value,
          "sold-out-bar": option.soldOut
        });
        const radioButtonContainerClassList = classNames(
          "radio-button-container",
          {
            "radio-button-container__wrapper": html
          },
          {
            horizontal: horizontal
          }
        );
        const radioButtonContentClassList = classNames("radio-button__content", `radio-button__content--${alignment}`, {
          "sold-out": option.soldOut
        });
        const labelClassName = classNames(isDisabled && checked?.value !== value ? "label disabled" : "label", {
          horizontal: horizontal
        });
        return (
          <div key={index} className={radioButtonContainerClassList} onClick={() => !isDisabled && !option.soldOut && handleSelect(option)} onKeyDown={event => selectWithKeyboardKeys(event, option)} tabIndex="0">
            <div className={radioButtonContentClassList} tabIndex="-1">
              <div
                className={classNames("radio-button", {
                  disabled: isDisabled && checked?.value !== value,
                  checked: checked?.value === value,
                  "sold-out": true //soldOut
                })}
              >
                <div className={radioButtonClassList} />
              </div>
              {html ? html(option) : <p className={labelClassName}>{label}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

RadioButtonGroup.propTypes = {
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
      html: PropTypes.func
    })
  ),
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  html: PropTypes.func,
  alignment: PropTypes.oneOf(["top", "center", "bottom"]),
  horizontal: PropTypes.bool
};

RadioButtonGroup.defaultProps = {
  alignment: "center"
};

export default RadioButtonGroup;
